<template>
  <div class="user">
    <div class="user-container">
      <div class="top">
        <div class="title">账户信息</div>
        <img class="closeBtn" :src="closeIcon" @click="close" />
        <!-- <div class="closeBtn" @click="close">关闭</div> -->
      </div>
      <div class="content">
        <div class="avatar">
          <img class="avatar-img" :src="avatarImg" />
          <div class="avatar-btn">修改头像</div>
          <input
            type="file"
            accept=".jpeg,.jpg,.png"
            class="avatar-upload"
            @change="handleFileChange"
          />
        </div>
      </div>
      <div class="info">
        <div class="info-title">您的账户</div>
        <el-input v-model="uid" class="search-input" type="input" disabled />
      </div>
      <div class="info">
        <div class="info-title">您的名称</div>
        <el-input
          v-model="name"
          class="search-input"
          type="input"
          placeholder="请输入您的名称"
        />
      </div>
      <div class="info">
        <div class="info-title">您所在的学校名称</div>
        <el-input
          v-model="schoolName"
          class="search-input"
          type="input"
          placeholder="请输入您所在的学校名称"
        />
      </div>
      <div class="info">
        <div class="info-title">您所在的学校类型</div>
        <div class="info-btns">
          <div
            v-for="(school, index) in schoolTypeList"
            :key="index"
            class="info-btn"
            :class="{ selectBtn: schoolType === school.id }"
            @click="select('school', school)"
          >
            {{ school.name }}
          </div>
        </div>
      </div>
      <div class="info">
        <div class="info-title">您所在教学段</div>
        <div class="info-btns">
          <div
            v-for="(period, index) in periodTypeList"
            :key="index"
            class="info-btn"
            :class="{ selectBtn: periodId === period.id }"
            @click="select('period', period)"
          >
            {{ period.name }}
          </div>
        </div>
      </div>
      <div class="info">
        <div class="info-title">您所在教的学科</div>
        <div class="info-btns">
          <div
            v-for="(subject, index) in subjectTypeList"
            :key="index"
            class="info-btn"
            :class="{ selectBtn: subjectId === subject.id }"
            @click="select('subject', subject)"
          >
            {{ subject.name }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="submitBtn" @click="submit">保存</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCommonInfo } from "@/api/common";
import { getUserInfo } from "@/api/user";
import { modUserInfo } from "@/api/user.js";
import { mapGetters } from "vuex";

export default {
  name: "UserCenter",
  components: {},
  data() {
    return {
      subjectTypeList: [],
      periodTypeList: [],
      schoolTypeList: [],
      schoolType: null,
      periodId: null,
      subjectId: null,
      name: null,
      uid: null,
      schoolName: null,
      closeIcon: require("@/assets/images/laoshibang/closeEditDialog.png"),
      avatarImg: require("@/assets/images/laoshibang/user-icon.png"),
    };
  },
  computed: {
    ...mapGetters(["TAL_ID", "isUserEditDialog", "userInfo"]),
  },
  watch: {
    isUserEditDialog(newVal, oldVal) {
      this.getUserInfo();
    },
  },

  mounted() {
    getCommonInfo().then((res) => {
      if (res.code === 200) {
        const { periodTypeList, schoolTypeList, subjectTypeList } = res.data;
        this.subjectTypeList = subjectTypeList;
        this.periodTypeList = periodTypeList;
        this.schoolTypeList = schoolTypeList;
      }
    });
    getUserInfo().then((res) => {
      if (res.code === 200) {
        const { schoolName, schoolType, uname, period, subject, avatar, uid } =
          res.data;
        this.uid = uid;
        this.name = uname;
        this.schoolName = schoolName;
        this.schoolType = schoolType;
        this.periodId = period;
        this.subjectId = subject;
        if (avatar) {
          this.avatarImg = avatar;
        }
        this.$store.commit("user/SET_USERINFO", {
          data: { userInfo: { ...res.data } },
        });
      }
    });
  },
  methods: {
    select(type, item) {
      switch (type) {
        case "school":
          this.schoolType = item.id;
          break;
        case "period":
          this.periodId = item.id;
          break;
        case "subject":
          this.subjectId = item.id;
          break;
      }
    },
    submit() {
      const params = {
        subject: this.subjectId,
        period: this.periodId,
        schoolType: this.schoolType,
        uname: this.name,
        schoolName: this.schoolName,
      };
      modUserInfo(params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "设置成功",
            type: "success",
          });
          this.$store.commit("user/SET_USERINFO", {
            data: { userInfo: { ...res.data } },
          });
          this.$store.commit("app/IS_USER_EDIT_DIALOG", false);
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    close() {
      this.$store.commit("app/IS_USER_EDIT_DIALOG", false);
    },
    handleFileChange(e) {
      const files = e.target.files;
      if (files && files[0]) {
        const file = files[0];
        if (file.size > 1024 * 1024 * 2) {
          return this.$message.error("头像尺寸过大，请选择小于2M的图片");
        }
        window.TAL_UC.uploadPhoto({
          data: {
            avatar: file, // 这个Fail是上传图片的file对象
            tal_id: this.TAL_ID, // 好未来用户Id
          },
          success: (res) => {
            const { errcode } = res;
            if (errcode === 0) {
              this.avatarImg = res.data.avatar_url;
              modUserInfo({ avatar: res.data.avatar_url }).then((res) => {
                if (res.code === 200) {
                  this.$message.success("上传成功", res.data);
                  this.$store.commit("user/SET_USERINFO", {
                    data: { userInfo: { ...res.data, avatar: this.avatarImg } },
                  });
                }
              });
            }
          },
          fail: (error) => {
            if (error.errcode !== 11100) {
              this.$message.error(error.errmsg);
            } else {
              this.$message.error("上传失败，请重试");
            }
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.user {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(50, 50, 51, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px 0;
}
.user-container {
  width: 689px;
  background-color: #fff;
  border-radius: 10px;
  padding: 33px 30px;
  margin: auto;
  position: relative;
}
.title {
  color: #0f0f10;
  font-family: "PingFang SC";
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.info {
  margin-top: 14px;
  &-title {
    color: #0f0f10;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 13px;
  }
  &-btns {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 16px;
  }
  &-btn {
    width: 113px;
    height: 46px;
    flex-shrink: 0;
    color: #323233;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 10px;
    border: 1px solid #eaeaea;
    text-align: center;
    line-height: 46px;
    &:hover {
      cursor: pointer;
      color: #0d70ed;
      border: 1px solid #0d70ed;
    }
  }
}
.selectBtn {
  color: #0d70ed;
  border: 1px solid #0d70ed;
}
.submitBtn {
  width: 160px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(153deg, #3774f3 -24.36%, #1a87f4 106.05%);
  color: #fff;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px; /* 157.143% */
  margin: auto;
  margin-top: 34px;
  &:hover {
    cursor: pointer;
  }
}
.top {
  display: flex;
  justify-content: space-between;
}
.closeBtn {
  width: 19px;
  height: 19px;
  flex-shrink: 0;
  &:hover {
    cursor: pointer;
  }
}
.search-input {
  width: 371px;
}
.content {
  overflow: visible;
}
.avatar {
  margin-top: 14px;
  display: flex;
  align-items: center;
  width: 200px;
  // height: 50px;
  flex-shrink: 0;
  gap: 15px;
  position: relative;
  &-img {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 25px;
  }
  &-btn {
    width: 90px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    flex-shrink: 0;
    border-radius: 12px;
    border: 1px solid #0f79ee;
    color: #0d70ed;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin-left: auto;
  }

  &-upload {
    position: absolute;
    cursor: pointer;
    width: 90px;
    height: 40px;
    top: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }
}
</style>
